<template>
  <div class="brand">
    <div class="brand-head">
      <p><s-icon type="diamond" size="18"></s-icon>品牌严选</p>
      <router-link :to="{name: 'CakeBrands'}">更多<van-icon name="arrow" /></router-link>
    </div>
    <div class="brand-list">
      <div class="brand-item" v-for="item of list" :key="item.cat_id" @click="routerLinkTo(item.cat_id)">
        <div class="brand-item-img">
          <img :src="item.cat_pic" />
        </div>
        <div class="brand-item-name">
          {{ item.cat_name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
    }
  },
  methods: {
    routerLinkTo (id) {
      this.$router.push({
        name: 'CakeBrandDetail',
        query: {
          bId: id
        }
      })
    }
  },
}
</script>
<style lang="scss" scoped>
.brand{
    background: #fff;
    margin: 0.3rem auto;
    width: calc(6.68rem - 0.1rem);
    border-radius: 12px;
    padding: 0.1rem;
.brand-head{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0.1rem;
  p {
    font-size: 0.32rem;
    font-weight: 800;
    margin: 0.1rem 0;
  }
  a {
    font-size: 0.24rem;
    color: $cake-text-grey;
  }
}
.brand-list{
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  margin: 0.1rem auto;
  font-size: 0.28rem;
  .brand-item {
    margin: 5px 0;
    .brand-item-img{
      width: 1rem;
      height: 1rem;
      padding: 0.2rem;
      border: 1px solid #CCCCCC;
      border-radius: 12px;
      img{
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .brand-item-name {
      color: $cake-text-darkgrey;
      font-size: .2rem;
      text-align: center;
      margin: 0.05rem;
      font-weight: 500;
    }
  }
}

}

</style>